import React from "react";
import "./homestandalonetext.css"
import {ContainerComponent} from "../../../app/components/container/ContainerComponent";

export function HomeStandaloneTextComponent({title, children}) {
    return (
        <ContainerComponent>
            <div className="homeStandaloneText">
                <h2>{title}</h2>
                <div className="homeStandaloneDescription">
                    {children}
                </div>
            </div>
        </ContainerComponent>
    )
}
